module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-hum-7bdaea109826249d3788711e538c5c82.png";